import slice from './reducer'
import emailSignatureSaga from './sagas'

export const {
  fetchRequest: fetchEmailSignatureRequest,
  fetchSuccess: fetchEmailSignatureSuccess,
  fetchError: fetchEmailSignatureError,
  editSuccess: editEmailSignatureSuccess,
  editRequested: editEmailSignatureRequested,
  editError: editEmailSignatureError,
} = slice.actions

export default slice.reducer
export { emailSignatureSaga }
